class RoamWearReviews extends HTMLElement {
  constructor() {
    super();
    this.scrollPrevious = this.scroll.bind(this, -1);
    this.scrollNext = this.scroll.bind(this, 1);
    this.syncControls = this.syncControls.bind(this);
  }

  connectedCallback() {
    this.strip = this.querySelector('.rw-scroll');
    this.previousButton = this.querySelector('.rw-arrow--prev');
    this.nextButton = this.querySelector('.rw-arrow--next');

    this.previousButton.addEventListener('click', this.scrollPrevious);
    this.nextButton.addEventListener('click', this.scrollNext);
    this.strip.addEventListener('scroll', this.syncControls, { passive: true });

    this.syncAfterResize = theme.utils.debounce(100, this.syncControls);
    window.addEventListener('resize', this.syncAfterResize);

    this.classList.add('rw-reviews--ready');
    this.syncControls();
  }

  disconnectedCallback() {
    this.previousButton.removeEventListener('click', this.scrollPrevious);
    this.nextButton.removeEventListener('click', this.scrollNext);
    this.strip.removeEventListener('scroll', this.syncControls);
    window.removeEventListener('resize', this.syncAfterResize);
    this.classList.remove('rw-reviews--ready');
  }

  scroll(direction) {
    const card = this.strip.querySelector('.rw-card');
    const gap = parseFloat(getComputedStyle(this.strip).columnGap) || 0;
    const distance = card.getBoundingClientRect().width + gap;

    this.strip.scrollBy({
      behavior: 'smooth',
      left: direction * distance,
    });
  }

  syncControls() {
    const maxScroll = this.strip.scrollWidth - this.strip.clientWidth;
    const canScroll = maxScroll > 1;

    this.previousButton.disabled = !canScroll || this.strip.scrollLeft <= 1;
    this.nextButton.disabled = !canScroll || this.strip.scrollLeft >= maxScroll - 1;
  }
}

customElements.define('roam-wear-reviews', RoamWearReviews);
